import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-sm font-medium tracking-widest text-muted-foreground">404</p>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          This page does not exist, or you no longer have access to it. Check the
          address or return to your workspace.
        </p>
      </div>
      <Button asChild className="mt-1">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
